module.exports = __webpack_public_path__ + "img/norway-digestive-diseases-male.9b199094.png";